import React from "react";
import "./App.css";
import "./index.css";

import DisableInspect from "./DisableInspect";

import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Login from "./components/login/Login";
import Recording_List from "./components/student/recording-list/Recording_List";
import "./components/common_components/common_css/common_css.css";
import "./components/common_components/common_css/common_table_css.css";
import Student_Detail from "./components/student/student_detail/Student_Detail";
import Student_Detail_Create from "./components/student/student_detail/create/Student_Detail_Create";
import Student_Detail_Edit from "./components/student/student_detail/edit/Student_Detail_Edit";

import Host_Detail from "./components/host/host_details/Host_Detail";
import Host_Detail_Create from "./components/host/host_details/create/Host_Detail_Create";
import Host_Detail_Edit from "./components/host/host_details/edit/Host_Detail_Edit";
import Attendance_List from "./components/student/attendance/Attendance_List";
import Notification from "./components/student/notification/Notification";
import Notification_Create from "./components/student/notification/create/Notification_Create";
import Notification_Edit from "./components/student/notification/edit/Notification_Edit";
import All_Recording_List from "./components/student/all-recording/All_Recording_List";
import AppSetup from "./components/student/app-setup/AppSetup";
import AppSetupEdit from "./components/student/app-setup/edit/Appsetup_Edit";

function App() {
  const location = useLocation();
  const hideHeader = location.pathname === "/";

  return (
    <>
      <DisableInspect />
      {/* <ScrollToTop /> */}
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Login />} />

        {/*------------------------------------------------------------STUDENT DETAIL------------------------------------------ */}

        <Route path="/student/detail" element={<Student_Detail />} />
        <Route
          path="/student/detail/create"
          element={<Student_Detail_Create />}
        />
        <Route
          path="/student/detail/edit/:id"
          element={<Student_Detail_Edit />}
        />

        <Route path="/student/recording" element={<Recording_List />} />

        {/* ------------------------------------------------Host----------------------------------------------------------- */}

        <Route path="/host/detail" element={<Host_Detail />} />
        <Route path="/host/detail/create" element={<Host_Detail_Create />} />
        <Route path="/host/detail/edit/:id" element={<Host_Detail_Edit />} />
        {/* RECORDING LIST */}
        <Route path="/student/recording" element={<Recording_List />} />

        {/* ATTENDANCE LIST */}
        <Route path="/student/attendance" element={<Attendance_List />} />

        {/* NOTIFICATION */}
        <Route path="/student/notification" element={<Notification />} />

        <Route
          path="/student/notification/create"
          element={<Notification_Create />}
        />

        <Route
          path="/student/notification/edit/:id"
          element={<Notification_Edit />}
        />

        {/* ALL RECORDING LIST */}
        <Route path="/student/all-recording" element={<All_Recording_List />} />

        <Route path="/student/app-setup" element={<AppSetup />} />
        <Route path="/student/app-setup/:id" element={<AppSetupEdit />} />
      </Routes>
    </>
  );
}

export default App;
